import { Box } from 'braid-design-system';

import * as styles from './MediaContainer.css';

export interface Props {
  src: string;
}

const IframeContainer = ({ src }: Props) => (
  <Box
    position="relative"
    overflow="hidden"
    className={styles.mediaRatio['16x9']}
  >
    <iframe
      src={src}
      allow="encrypted-media"
      allowFullScreen
      className={styles.item}
    />
  </Box>
);

export default IframeContainer;
